/** MCP OAuth authorize query (Gateway → Portal) */

export type McpOAuthParams = {
  clientId: string;
  redirectUri: string;
  codeChallenge: string;
  codeChallengeMethod: string;
  state: string | null;
  responseType: string | null;
};

export function parseMcpOAuthSearch(search: string): McpOAuthParams | null {
  const qs = search.startsWith('?') ? search.slice(1) : search;
  if (!qs) return null;
  const params = new URLSearchParams(qs);
  const redirectUri = params.get('redirect_uri');
  const codeChallenge = params.get('code_challenge');
  if (!redirectUri || !codeChallenge) return null;

  return {
    clientId: params.get('client_id') || 'itops-mcp-public-dev',
    redirectUri,
    codeChallenge,
    codeChallengeMethod: params.get('code_challenge_method') || 'S256',
    state: params.get('state'),
    responseType: params.get('response_type'),
  };
}

export function isMcpOAuthFlow(pathname: string, search: string): boolean {
  if (pathname.endsWith('/mcp/oauth/callback')) return true;
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
  return params.get('mcp_oauth') === '1' && !!params.get('redirect_uri') && !!params.get('code_challenge');
}

export function buildOAuthRedirect(redirectUri: string, code: string, state: string | null): string {
  const url = new URL(redirectUri);
  url.searchParams.set('code', code);
  if (state) url.searchParams.set('state', state);
  return url.toString();
}

export function navigateAfterAuth(
  returnUrl: string | null | undefined,
  navigate: (opts: { to: string }) => void,
  navigateToService: (url: string) => void,
  landingHint?: { landing: string; persona?: string | null } | null,
): void {
  if (returnUrl) {
    const target = decodeURIComponent(returnUrl);
    if (target.startsWith('/')) {
      window.location.assign(target);
      return;
    }
    navigateToService(target);
    return;
  }

  if (landingHint?.landing) {
    const path = landingHint.landing;
    if (path.startsWith('http') || path.includes('/asset-dashboard')) {
      navigateToService(path.startsWith('http') ? path : `${window.location.origin}${path}`);
      return;
    }
    navigate({ to: path });
    return;
  }

  navigate({ to: '/entry' });
}
